export default "__VITE_ASSET__5758506f__"